<template>
  <div class="table-wrapper">

    <!-- 🔍 Buscador -->
    <div class="table-search">
      <input
        v-model="searchText"
        type="text"
        placeholder="Buscar por dependencia o subgrupo"
        @input="onSearch"
      />
    </div>
    <ag-grid-vue
      ref="agGrid"
      class="ag-theme-material"
      :style="{ width: '100%', height: expanded ? '480px' : '240px' }"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :defaultColDef="defaultColDef"
      rowSelection="multiple"
      :isRowSelectable="isRowSelectable"
      :overlayNoRowsTemplate="overlayNoRowsTemplate"
      :getRowId="getRowId"
      :tooltipShowDelay="400"
      :tooltipHideDelay="2000"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
    />
    <div class="table-expand-btn" @click="toggleExpand">
      {{ expanded ? '▲ Contraer' : '▼ Expandir' }}
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import BarraRenderer from './BarraRenderer.vue'

export default {
  name: "ResultsTableGroups",
  components: { 
    AgGridVue,
    /* eslint-disable-next-line vue/no-unused-components */
    barraRenderer: BarraRenderer
  },

  data() {
    return {
      searchText: '',
      expanded: false,
      gridApi: null,
      columnDefs : [
        {
          headerName: "",
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 50,
          maxWidth: 50,
          minWidth: 40,
          flex: 0,
          sortable: false,
          filter: false,
          resizable: false,
          getQuickFilterText: () => ''
        },
        { headerName: "Dependencia",
          field: "dependency",
          tooltipField: "dependency",
          minWidth:200,
          getQuickFilterText: params => params.value ? params.value.toString().toLowerCase() : ''
        },
        {
          headerName: "Subgrupo",
          field: "subgrupo",
          tooltipField: "subgrupo",
          minWidth:200,
          getQuickFilterText: params => params.value ? params.value.toString().toLowerCase() : '' },
        {
          headerName: "n",
          field: "n",
          width: 80,
          maxWidth: 80,
          minWidth: 40,
          flex: 0,
          cellStyle: {
            textAlign: 'left',
            fontWeight: '400'
          }
        },
        {
          headerName: "Colaboración",
          field: "clanActual",
          cellRenderer: "barraRenderer",  // Directamente el componente
          cellRendererParams: { deseadaField: "clanDeseada" }
        },
        {
          headerName: "Creación",
          field: "adhActual",
          cellRenderer: "barraRenderer",
          cellRendererParams: { deseadaField: "adhDeseada" }
        },
         {
          headerName: "Competencia",
          field: "merActual",
          cellRenderer: "barraRenderer",
          cellRendererParams: { deseadaField: "merDeseada" }
        },
        {
          headerName: "Control",
          field: "jerActual",
          cellRenderer: "barraRenderer",
          cellRendererParams: { deseadaField: "jerDeseada" }
        }
       
      ],
      defaultColDef: {
        flex: 1,
        minWidth: 10,
        resizable: true,
        sortable: true,
        filter: true
      },
      overlayNoRowsTemplate: `
        <div class="custom-no-rows">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none"><path fill="#ffb02e" d="M15.999 29.998c9.334 0 13.999-6.268 13.999-14c0-7.73-4.665-13.998-14-13.998C6.665 2 2 8.268 2 15.999s4.664 13.999 13.999 13.999"/><path fill="#fff" d="M10.42 19.224a4.206 4.206 0 1 0 0-8.411a4.206 4.206 0 0 0 0 8.411m11.148.077a4.244 4.244 0 1 0 0-8.489a4.244 4.244 0 0 0 0 8.49"/><path fill="#402a32" d="M10.017 6.37c-.19.703-.525 1.355-1.065 1.83c-.533.467-1.307.8-2.452.8a.5.5 0 0 0 0 1c1.355 0 2.373-.4 3.112-1.049c.73-.642 1.146-1.49 1.37-2.32a.5.5 0 1 0-.965-.262m11.966.001c.19.703.525 1.355 1.065 1.83c.533.467 1.307.8 2.452.8a.5.5 0 0 1 0 1c-1.355 0-2.373-.4-3.112-1.049c-.73-.642-1.146-1.49-1.37-2.32a.5.5 0 1 1 .965-.262M16 23c-1.286 0-2.014.428-2.293.707a1 1 0 0 1-1.414-1.414C13.013 21.573 14.286 21 16 21c1.64 0 2.981.567 3.707 1.293a1 1 0 0 1-1.414 1.414C18.019 23.433 17.228 23 16 23m-2-8a3 3 0 1 1-6 0a3 3 0 0 1 6 0m10 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path fill="#3f5fff" d="M1 19.5a2.5 2.5 0 0 1 5 0v4a2.5 2.5 0 0 1-5 0z"/></g></svg>
          <p style="color: #7a7a7a">No hay procesos creados aún</p>
        </div>
      `,
       
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      this.$nextTick(() => {
        if (this.gridApi) this.gridApi.sizeColumnsToFit();
      });
    },
    getRowId(params) {
      return `${params.data.dependency}__${params.data.subgrupo || ''}`;
    },
    isRowSelectable(rowNode) {
      return rowNode.data && rowNode.data.n >= 5;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    onSearch() {
      if (this.gridApi) {
        this.gridApi.setQuickFilter(this.searchText.toLowerCase());
      }
    },
    onResize() {
        if (this.gridApi) {
          this.gridApi.sizeColumnsToFit();
        }
    },
    onSelectionChanged() {
      const selected = this.gridApi.getSelectedRows();
      this.$emit('selection-changed', selected);
    },
    clearSelection() {
      if (this.gridApi) {
        this.gridApi.deselectAll();
      }
    },
    restoreSelection(items) {
      if (!this.gridApi) return;
      this.gridApi.forEachNode(node => {
        const matches = items.some(
          item => item.dependency === node.data.dependency && item.subgrupo === node.data.subgrupo
        );
        node.setSelected(matches && node.selectable, false, true);
      });
      this.gridApi.refreshCells({ force: true });
    }
  },
    props: {
      rowData: {
        type: Array,
        required: true
      }
    }
}
</script>
<style>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-material.css";

  .table-search {
    margin-bottom: 8px;
  }

  .table-wrapper {
    position: relative;
  }

.table-search {
  display: flex;
  justify-content: flex-end;   /* 👉 lo manda a la derecha */
  margin-top: -42px;          /* 👉 súbelo hasta el título (ajusta este valor) */
  margin-bottom: 8px;
  padding-right: 8px;         /* opcional */
}

.table-search input {
  width: 400px;
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  outline: none;
}

.table-search input:focus {
  border-color: #660099;
}


  .table-search input:focus {
    border-color: #660099;
  }

  .ag-theme-material .ag-cell-focus,
  .ag-theme-material .ag-cell:focus {
    border: none !important;
    outline: none !important;
  }

  .ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after,
  .ag-theme-material .ag-checkbox-input-wrapper.ag-indeterminate::after {
    color: #661699;
  }

  .ag-theme-material {
    transition: height 0.3s ease;
  }

  .table-expand-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
    font-size: 11px;
    color: #660099;
    cursor: pointer;
    user-select: none;
  }

  .table-expand-btn:hover {
    text-decoration: underline;
  }

  /* .table-wrapper {
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
    overflow-x: none;
  } */
</style>


// WEBPACK FOOTER //
// src/components/cultura/sections/results/ResultsTableGroups.vue